export default "__VITE_ASSET__5X1noNtT__"